import { Action } from '@ngrx/store';
import { Artist } from '@shared/models/artist';
import { Favourite } from '@shared/models/favourite';
import { Filter } from '@shared/models/filter';
import { Interest } from '@shared/models/interest';
import { ProductType } from '@shared/models/product-type';

export enum PreferencesActionTypes {
  LOAD_ARTISTS = '[Preferences] Load Artists',
  LOAD_ARTISTS_NEXT_PAGE = '[Preferences] Load Artists Next Page',
  LOAD_ARTISTS_SUCCESS = '[Preferences] Load Artists Success',
  LOAD_ARTISTS_FAILURE = '[Preferences] Load Artists Failure',
  TOGGLE_PREFERENCE = '[Preferences] Toggle Preference',
  ARTIST_INITIAL_FILTER_CHANGE = '[Preferences] Artist Initial Filter Change',
  ARTIST_SEARCH_TERM_CHANGE = '[Preferences] Artist Search Term Change',
  ARTIST_FOLLOWING_FILTER_CHANGE = '[Preferences] Artist Following Filter Change',
  LOAD_FAVOURITES = '[Preferences] Load Favourites',
  LOAD_FAVOURITES_NEXT_PAGE = '[Preferences] Load Favourites Next Page',
  LOAD_FAVOURITES_SUCCESS = '[Preferences] Load Favourites Success',
  LOAD_FAVOURITES_FAILURE = '[Preferences] Load Favourites Failure',
  LOAD_PRIMARY_INTERESTS = '[Preferences] Load Primary Interest',
  LOAD_PRIMARY_INTERESTS_NEXT_PAGE = '[Preferences] Load Primary Interest Next Page',
  LOAD_PRIMARY_INTERESTS_SUCCESS = '[Preferences] Load Primary Interest Success',
  LOAD_PRIMARY_INTERESTS_FAILURE = '[Preferences] Load Primary Interest Failure',
  PRIMARY_INTERESTS_SEARCH_TERM_CHANGE = '[Preferences] Primary Interest Search Term Change',
  PRIMARY_INTERESTS_CATEGORY_FILTER = '[Preferences] Primary Interest Category Filter',
}

export class LoadArtistsAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_ARTISTS;
}

export class LoadArtistsNextPageAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_ARTISTS_NEXT_PAGE;
}

export class LoadArtistsSuccessAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_ARTISTS_SUCCESS;
  constructor(public artists: Artist[], public nextPage: boolean) {}
}

export class LoadArtistsFailureAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_ARTISTS_FAILURE;
}

export class TogglePreferenceAction implements Action {
  readonly type = PreferencesActionTypes.TOGGLE_PREFERENCE;
  constructor(public id: string) {}
}

export class ArtistInitialFilterChangeAction implements Action {
  readonly type = PreferencesActionTypes.ARTIST_INITIAL_FILTER_CHANGE;
  constructor(public initialFilter: string) {}
}

export class ArtistSearchTermChangeAction implements Action {
  readonly type = PreferencesActionTypes.ARTIST_SEARCH_TERM_CHANGE;
  constructor(public searchTerm: string) {}
}

export class ArtistFollowingFilterChangeAction implements Action {
  readonly type = PreferencesActionTypes.ARTIST_FOLLOWING_FILTER_CHANGE;
}

export class LoadFavouritesAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_FAVOURITES;
  constructor(public productTypes: ProductType[]) {}
}

export class LoadFavouritesNextPageAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_FAVOURITES_NEXT_PAGE;
  constructor(public productTypes: ProductType[]) {}
}

export class LoadFavouritesSuccessAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_FAVOURITES_SUCCESS;
  constructor(public favourites: Favourite[], public nextPage: boolean) {}
}

export class LoadFavouritesFailureAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_FAVOURITES_FAILURE;
}

export interface LoadPrimaryInterestsActionPayload {
  resetPagination: boolean;
}

export class LoadPrimaryInterestsAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_PRIMARY_INTERESTS;
  constructor(public payload: LoadPrimaryInterestsActionPayload) {}
}

export interface LoadPrimaryInterestsNextPageActionPayload {
  resetPagination: boolean;
}

export class LoadPrimaryInterestsNextPageAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_PRIMARY_INTERESTS_NEXT_PAGE;
  constructor(public payload: LoadPrimaryInterestsNextPageActionPayload) {}
}

export interface PrimaryInterestSearchTermChangeActionPayload {
  searchPhrase: string;
  resetPagination: boolean;
}

export class PrimaryInterestSearchTermChangeAction implements Action {
  readonly type = PreferencesActionTypes.PRIMARY_INTERESTS_SEARCH_TERM_CHANGE;
  constructor(public payload: PrimaryInterestSearchTermChangeActionPayload) {}
}

export interface PrimaryInterestCategoryFilterActionPayload {
  selectedFilters: Filter[];
  resetPagination: boolean;
}

export class PrimaryInterestCategoryFilterAction implements Action {
  readonly type = PreferencesActionTypes.PRIMARY_INTERESTS_CATEGORY_FILTER;
  constructor(public payload: PrimaryInterestCategoryFilterActionPayload) {}
}

export interface LoadPrimaryInterestsSuccessActionPayload {
  primaryInterests: Interest[];
  nextPage: boolean;
  nextPageIndex: number | null;
}

export class LoadPrimaryInterestsSuccessAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_PRIMARY_INTERESTS_SUCCESS;
  constructor(public payload: LoadPrimaryInterestsSuccessActionPayload) {}
}

export class LoadPrimaryInterestsFailureAction implements Action {
  readonly type = PreferencesActionTypes.LOAD_PRIMARY_INTERESTS_FAILURE;
}

export type PreferencesAction =
  | LoadArtistsAction
  | LoadArtistsNextPageAction
  | LoadArtistsSuccessAction
  | LoadArtistsFailureAction
  | TogglePreferenceAction
  | ArtistInitialFilterChangeAction
  | ArtistSearchTermChangeAction
  | ArtistFollowingFilterChangeAction
  | LoadFavouritesAction
  | LoadFavouritesNextPageAction
  | LoadFavouritesSuccessAction
  | LoadFavouritesFailureAction
  | LoadPrimaryInterestsAction
  | LoadPrimaryInterestsNextPageAction
  | LoadPrimaryInterestsSuccessAction
  | LoadPrimaryInterestsFailureAction
  | PrimaryInterestSearchTermChangeAction
  | PrimaryInterestCategoryFilterAction;
